import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FormControl, MenuItem } from '@mui/material';
import React from 'react';
import { countries, SelectField } from '../../UserDataManagement';
const regions = ['None'].concat(countries.filter((country) => country.Code === 'GB')[0].Regions);
export const RegionDropdown = (props) => {
    const handleChange = React.useCallback((e) => {
        props.onChange(e.target.value);
    }, [props]);
    return (_jsx(_Fragment, { children: _jsx(FormControl, { sx: { width: '100%' }, children: _jsx(SelectField, { name: "regionCode", label: "Bank holiday region", sx: { width: '100%' }, value: props.regionCode, onChangeOverride: handleChange, required: true, children: regions.map((em, index) => (_jsx(MenuItem, { value: em, children: em }, index))) }) }) }));
};
